export const common = {
  edubox: 'EDUbox',
  talk: 'Exposé',
  start: 'Commence',
  stop: 'Stop',
  previous: 'Précédent',
  next: 'Suivant',
  error: {
    noConnection: 'Impossible de se connecter au serveur',
    invalidRoom: 'Pièce non valable',
  },
};
